import { PreviewPage } from '@/components/Widget/Embed/PreviewPage';

const WidgetPreviewPage = () => {
  return (
    <div style={{ height: 'calc(100vh - 32px)' }}>
      <PreviewPage />
    </div>
  );
};

export default WidgetPreviewPage;
